import React from 'react';
import AboutMe from '../sections/AboutMe';
import CurrentWork from '../sections/CurrentWork';
import ContactMe from '../sections/ContactMe';
import { useLanguage } from '../LanguageContext';
import T from '../components/T';
import { Helmet } from 'react-helmet-async';

const HomePage = () => {
  const { t } = useLanguage(); // Use the custom hook

  return (
    <div className="min-h-screen py-20 md:py-16 lg:py-0 bg-[var(--color-bg-primary)] transition-colors duration-300" style={{fontFamily: 'Short Stack, cursive'}}>
      <Helmet>
        <title>{t('seo.home.title')}</title>
        <meta name="description" content={t('seo.home.description')} />
        <meta property="og:title" content={t('seo.home.title')} />
        <meta property="og:description" content={t('seo.home.description')} />
        <meta property="og:image" content="https://pfjacobs.com/images/profile_without_bg.png" />
        <meta property="og:url" content="https://pfjacobs.com/" />
      </Helmet>
      <div className="container mx-auto px-6 py-[2rem] md:py-[4rem] lg:py-[0rem] lg:flex lg:items-center lg:h-screen max-w-[95vw]">
        <div className="flex flex-col md:flex-row items-center overflow-hidden transition-colors duration-300">
          <div className="md:w-1/2 flex justify-center items-center">
            
            <img 
              src="./images/profile_without_bg.png" 
              alt="Pieter Jacobs Presenting" 
              className="w-full max-w-md h-64 md:h-auto md:max-h-96 object-cover rounded-lg"
              decoding='async'
              loading='eager'
            />
          </div>
          <div className="md:w-1/2 py-6 md:p-12">
            <h1 className="text-3xl md:text-4xl lg:text-5xl text-[var(--color-text-primary)] mb-4 transition-colors duration-300" style={{fontFamily: 'Indie Flower, cursive'}}>
              <T k="homepage.frontpage.title" />
            </h1>
            <p className="text-base lg:text-lg text-[var(--color-text-secondary)] mb-10 transition-colors duration-300" style={{fontFamily: 'Short Stack, cursive'}}>
              <T k="homepage.frontpage.intro" />
            </p>
            {/* Scrolls to the Currently Building section below, on this
                same page, rather than navigating to /experience, so the
                button does what its own label implies. */}
            <button
                  type="button"
                  onClick={() => document.getElementById('currently-building')?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                  className="font-bold py-4 px-8 text-lg rounded-md transition duration-300"
                  style={{backgroundColor: 'var(--color-btn-primary)', color: 'var(--color-btn-text)', fontFamily: 'Short Stack, cursive', border: 'none', cursor: 'pointer'}}
                >
                   <T k="homepage.frontpage.explore" />
                </button>
          </div>
        </div>
      </div>
      {/* No drawn dividers between sections, site-wide — decided against
          entirely (was briefly made consistent across all three section
          boundaries here, then dropped just as quickly); whitespace/
          padding alone separates sections now, same as every other
          boxless/lineless decision made this round (filter pills, About
          Me tiles, timeline entries). */}
      <CurrentWork/>

      <AboutMe/>

      <ContactMe/>
    </div>
  );
};

export default HomePage;